const OTHER_CREDENTIALS = new Set(["Other", "Other Credentials"]);
const CREDENTIAL_PLACEHOLDERS = new Set(["Verified", "Unapproved"]);

export function getProviderDisplayCredentials(
  professionalCredentials: string | null | undefined,
  otherProfessionalCredentials: string | null | undefined
): string | null {
  if (!professionalCredentials) return null;

  if (OTHER_CREDENTIALS.has(professionalCredentials)) {
    if (
      otherProfessionalCredentials &&
      !CREDENTIAL_PLACEHOLDERS.has(otherProfessionalCredentials)
    ) {
      return otherProfessionalCredentials;
    }
    return null;
  }

  return professionalCredentials;
}

export function getProviderDisplayName(provider: {
  fullName?: string | null;
  firstName?: string;
  lastName?: string;
}): string {
  if (provider.fullName?.trim()) return provider.fullName.trim();
  return [provider.firstName, provider.lastName].filter(Boolean).join(" ");
}

export function getProviderFirstName(provider: {
  firstName?: string;
  fullName?: string | null;
}): string {
  if (provider.firstName?.trim()) return provider.firstName.trim();
  return provider.fullName?.trim().split(/\s+/)[0] ?? "Provider";
}
